import { useAuthStore } from '@/shared/store/auth.store';

// Shared empty sentinel: keeps the selector result referentially stable when
// the user is unauthenticated, otherwise useSyncExternalStore trips its
// "getSnapshot should be cached" guard and the component loops.
const SIN_PERMISOS: readonly string[] = Object.freeze([]);

export function usePermission(permiso: string | string[]): boolean {
  const permisos = useAuthStore(state => state.user?.permisos) ?? SIN_PERMISOS;
  if (Array.isArray(permiso)) {
    return permiso.some(p => permisos.includes(p));
  }
  return permisos.includes(permiso);
}
